import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { forwardRef, useState } from "react";
import { clsx } from "clsx";
import { Tooltip } from "../tooltip/index.js";
import { UnStyledButton } from "../button/index.js";
/* empty css          */
const ToolbarButton = forwardRef((t0, ref) => {
  const $ = c(14);
  const {
    label,
    onClick,
    ...props
  } = t0;
  const [error, setError] = useState(null);
  let t1;
  if ($[0] !== onClick) {
    t1 = (event) => {
      try {
        if (onClick) {
          onClick(event);
        }
        setError(null);
      } catch (t22) {
        const err = t22;
        setError(err instanceof Error ? err : new Error(`Toolbar button click failed: ${err}`));
      }
    };
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  const T0 = Tooltip;
  const T1 = UnStyledButton;
  const t2 = "button";
  const t3 = clsx("graphiql-toolbar-button", error && "error", props.className);
  const t4 = error ? error.message : label;
  const t5 = error ? "true" : props["aria-invalid"];
  let t6;
  if ($[2] !== T1 || $[3] !== handleClick || $[4] !== props || $[5] !== ref || $[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = /* @__PURE__ */ jsx(T1, { ...props, ref, type: t2, className: t3, onClick: handleClick, "aria-label": t4, "aria-invalid": t5 });
    $[2] = T1;
    $[3] = handleClick;
    $[4] = props;
    $[5] = ref;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== T0 || $[11] !== label || $[12] !== t6) {
    t7 = /* @__PURE__ */ jsx(T0, { label, children: t6 });
    $[10] = T0;
    $[11] = label;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
});
ToolbarButton.displayName = "ToolbarButton";
export {
  ToolbarButton
};
//# sourceMappingURL=index.js.map
